import {
  OfferStatus,
  OfferFilter,
} from 'src/common/apollo/types/swarmx/graphql'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'
import { ExpandedOfferFillType, Filters } from '../filters'
import dayjs from 'dayjs'

export const buildOffersFilter = (filters: Filters): OfferFilter => {
  const { depositAssets, withdrawalAssets, offerStatuses, timeRange } = filters
  const offersFilter: OfferFilter = {}

  if (depositAssets.length)
    offersFilter.depositAsset_ = { address_in: depositAssets.map(unifyAddress) }
  if (withdrawalAssets.length)
    offersFilter.withdrawalAsset_ = {
      address_in: withdrawalAssets.map(unifyAddress),
    }
  if (offerStatuses.length) {
    let expired: ExpandedOfferFillType.Expired | null = null
    const restOfferFillTypes: OfferStatus[] = []

    offerStatuses.forEach(val => {
      if (val === ExpandedOfferFillType.Expired) {
        expired = val
      } else {
        restOfferFillTypes.push(val as unknown as OfferStatus)
      }
    })

    if (expired) {
      offersFilter.expiryTimestamp_lt = dayjs().unix().toString()
    }
    offersFilter.offerStatus_in = restOfferFillTypes
  }
  if (timeRange) offersFilter.createdAt_gte = timeRange.toFixed(0)

  return offersFilter
}

export const getOffersFilterFromSearchParams = (
  searchParams: URLSearchParams
): Filters => {
  const getArrayFilter = (searchParams: URLSearchParams, key: keyof Filters) =>
    searchParams.get(key)?.split(',')?.filter(Boolean) || []

  const offerStatuses = getArrayFilter(
    searchParams,
    'offerStatuses'
  ) as ExpandedOfferFillType[]
  const timeRange = Number(searchParams.get('timeRange'))
  const depositAssets = getArrayFilter(searchParams, 'depositAssets')
  const withdrawalAssets = getArrayFilter(searchParams, 'withdrawalAssets')

  return {
    offerStatuses,
    timeRange,
    depositAssets,
    withdrawalAssets,
  }
}
